import React, { useState } from "react";
import { FloatingLabel, Form } from "react-bootstrap";
import { IoArrowForward } from "react-icons/io5";
import axios from "axios";
import * as s from "./index.module.scss";
import { useCfStore } from "@/components/CfTurnstile";
import { addToDataLayer, addEnhancedToDataLayer } from "@/utils/addToDataLayer";
import FormSubmissionMessage from "../FormSubmissionMessage";

const FormComponent = ({
  buttonText = "Get a loan offer now",
  placeholderText = "Please describe your items.",
  page = "",
  event = "Sell",
  sellItemDropdown = false,
}) => {
  const { token, reset } = useCfStore();
  const [itemToSell, setItemToSell] = useState("");
  const [submitMessage, setSubmitMessage] = useState({
    text: "",
    phoneLink: "",
  });
  const [success, setSuccess] = useState("");
  const [fail, setFail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    email: "",
    phone: "",
    sellItem: "",
    message: "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (!token) {
        window.alert("Checking for humans. Please try again in a minute.");
        setSubmitting(false);
        return;
      }

      let additionalFields = [];
      if (sellItemDropdown) {
        additionalFields.push({ key: "Sell Item", value: formData?.sellItem });
      }

      await axios.post("/api/hubspot", { formData });

      const res = await axios.post("/api/submit-form", {
        fields: [
          { key: "First Name", value: formData?.firstName },
          { key: "Email", value: formData?.email },
          { key: "Phone", value: formData?.phone },
          ...additionalFields,
          { key: "Message", value: formData?.message },
        ],
        page,
        firstName: formData?.firstName,
        email: formData?.email,
        sellItem: formData?.sellItem,
        event,
        recaptchaToken: token,
      });
      if (res?.status === 200) {
        setSubmitMessage({
          text: "Thank you for your inquiry. We will get back to you soon over an email or via a call. If you need assistance with anything else,",
          phoneLink: "(212) 913-9141",
        });
        setSuccess(true);
        if (event === "Sell") {
          addEnhancedToDataLayer(formData?.email);
        } else {
          addToDataLayer("Form Submission Get A Loan");
        }
        setFormData({
          firstName: "",
          email: "",
          phone: "",
          sellItem: "",
          message: "",
        });
      } else {
        setSubmitMessage({
          text: "Submission unsuccessful. Please try again",
          phoneLink: "",
        });
        setFail(true);
      }
    } catch (err) {
      setSubmitMessage({
        text: "Submission unsuccessful. Please try again",
        phoneLink: "",
      });
      setFail(true);
      console.log("ERROR: ", err);
    } finally {
      reset();
      setSubmitting(false);
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      {submitMessage?.text && (
        <FormSubmissionMessage
          fail={fail}
          success={success}
          submitMessage={submitMessage}
        />
      )}
      {!submitMessage?.text && (
        <>
          <FloatingLabel label="Your full name" className="mb-3 caption">
            <Form.Control
              type="text"
              placeholder="Your full name"
              value={formData?.firstName}
              className="caption"
              required={true}
              onChange={(e) => {
                setFormData({ ...formData, firstName: e.target.value });
              }}
            />
          </FloatingLabel>
          <FloatingLabel label="Your Email" className="mb-3 caption">
            <Form.Control
              type="email"
              placeholder="Your Email"
              value={formData?.email}
              className="caption"
              required={true}
              onChange={(e) => {
                setFormData({ ...formData, email: e.target.value });
              }}
            />
          </FloatingLabel>
          <FloatingLabel label="Phone number" className="mb-3 caption">
            <Form.Control
              type="tel"
              placeholder="Phone number"
              className="caption"
              required={true}
              value={formData?.phone}
              minLength="8"
              maxLength="12"
              onChange={(e) => {
                setFormData({ ...formData, phone: e.target.value });
              }}
            />
          </FloatingLabel>

          {sellItemDropdown && (
            <FloatingLabel
              controlId="floatingSelect"
              label="Select item to sell"
              className={`mb-3 ${itemToSell === "" ? s.no_select_input : ""}`}
            >
              <Form.Select
                aria-label="Select item to sell"
                value={itemToSell}
                required={true}
                onChange={(e) => {
                  setItemToSell(e.target.value);
                  setFormData({ ...formData, sellItem: e.target.value });
                }}
              >
                <option value=""></option>
                <option value="Luxury Watches">Luxury Watches</option>
                <option value="Jewelry">Jewelry</option>
                <option value="Diamonds">Diamonds</option>
                <option value="Gold">Gold</option>
                <option value="Gold Coins">Gold Coins</option>
                <option value="Platinum">Platinum</option>
                <option value="Silver">Silver</option>
                <option value="Designer Bag">Designer Bag</option>
                <option value="Other Item">Other Item</option>
              </Form.Select>
            </FloatingLabel>
          )}

          <FloatingLabel label={placeholderText} className="mb-3 caption">
            <Form.Control
              as="textarea"
              placeholder={placeholderText}
              value={formData?.message}
              className="caption"
              style={{ height: "100px" }}
              onChange={(e) => {
                setFormData({ ...formData, message: e.target.value });
              }}
            />
          </FloatingLabel>

          <button
            disabled={submitting}
            type="submit"
            className="btn btn-primary w-100 justify-content-center"
          >
            {buttonText}{" "}
            <IoArrowForward size="18px" style={{ marginLeft: "8px" }} />
          </button>
        </>
      )}
    </Form>
  );
};

{
  /* <script charset="utf-8" type="text/javascript" src="//js.hsforms.net/forms/embed/v2.js"></script>
    <script>
      hbspt.forms.create({
        region: "na1",
        portalId: "43771370",
        formId: "eed4ef4b-f3a7-4473-b8fd-0d3948e5c98a"
      });
    </script> */
}

export default FormComponent;
